import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\dev\\project\\bigtv_next\\app\\sportsanalysis\\analysis\\page.tsx");
